import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import Vue from "vue";
export const SET_CURRENT_TEMPLATE = "SET_CURRENT_TEMPLATE";
export const SET_TEMPLATES = "SET_TEMPLATES";
export const SET_PREDEFINED_TEMPLATES = "SET_PREDEFINED_TEMPLATES";
export const REMOVE_TEMPLATE = "REMOVE_TEMPLATE";
export const ADD_TEMPLATE = "ADD_TEMPLATE";
const mutations = {
  [SET_CURRENT_TEMPLATE]: (state, data) => {
    state.currentTemplate = data;
  },
  [SET_TEMPLATES]: (state, {
    byId,
    allIds
  }) => {
    state.userCreated.allIds = allIds;
    state.userCreated.byId = byId;
  },
  [SET_PREDEFINED_TEMPLATES]: (state, {
    byId,
    allIds
  }) => {
    state.predefinedTemplates.allIds = allIds;
    state.predefinedTemplates.byId = byId;
  },
  [REMOVE_TEMPLATE]: (state, templateId) => {
    var _context;
    Vue.delete(state.userCreated.byId, templateId);
    state.userCreated.allIds = _filterInstanceProperty(_context = state.userCreated.allIds).call(_context, id => id !== templateId);
  },
  [ADD_TEMPLATE]: (state, newTemplate) => {
    Vue.set(state.userCreated.byId, newTemplate.templateId, newTemplate);
    state.userCreated.allIds.push(newTemplate.templateId.toString());
  }
};
export default mutations;